exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#headerFloat {\n  position: fixed;\n  width: 150px;\n  left: 0px;\n  top: 0px;\n  padding: 10px;\n  color: white\n}\n\nimg#logo {\n  width: 60px;\n  margin-left: 10px;\n}\n\na {\n  color: white\n}\n\n#pageTable tr.mainHeader {\n  border-bottom: 1px solid #fff;\n}\n\n#pageTable tr.mainHeader td {\n  background: #444;\n  padding: 0\n}\n\n#pageTable {\n  width: 100%;\n}\n\n#pageTable #leftHeader, #pageTable #rightHeader {\n  min-width: 100px;\n  padding: 10px;\n}\n\n#pageTable #leftHeader {\n  text-align: left;\n}\n\n#pageTable #rightHeader {\n  text-align: right;\n  padding-right: 1em;\n}\n\n#middleHeader {\n  width: 800px;\n  vertical-align: bottom;\n}\n\n#mainPageTD {\n  padding:0;\n}\n\n#mainPageTD {\n  background: white;\n  min-height: 1000px;\n  padding: 20px;\n  min-width: 600px;\n}\n\n#adminColumn {\n  width:200px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = 378
// module chunks = 0